import { EsimPackage } from "@/lib/redux/features/esim/types";

/** API base price × quantity (excludes markup). */
export const getEsimPackageBaseTotal = (pkg: EsimPackage, quantity = 1): number =>
  (pkg.price ?? 0) * quantity;

/** Markup fee × quantity — also pass as `feeAmount` on create/checkout. */
export const getEsimPackageFeeMakeUpTotal = (pkg: EsimPackage, quantity = 1): number =>
  (pkg.feeMakeUp ?? 0) * quantity;

/** Display/checkout unit price: base + markup. */
export const getEsimPackageUnitPrice = (pkg: EsimPackage): number =>
  (pkg.price ?? 0) + (pkg.feeMakeUp ?? 0);

export const getEsimPackageTotalPrice = (
  pkg: EsimPackage,
  quantity = 1,
): number =>
  getEsimPackageBaseTotal(pkg, quantity) + getEsimPackageFeeMakeUpTotal(pkg, quantity);
